"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pages = exports.PAGEEVENTS = void 0;
var _eventEmitter = _interopRequireDefault(require("event-emitter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const PAGEEVENTS = {
  PAGELOAD: 'PAGELOAD',
  ERROR: 'ERROR'
};
exports.PAGEEVENTS = PAGEEVENTS;
class Pages {
  pageLoad(templateName, start, end) {
    const payload = {
      templateName,
      start,
      end
    };
    this.emit(PAGEEVENTS.PAGELOAD, payload);
  }
  error(name, content) {
    const payload = {
      name,
      content
    };
    this.emit(PAGEEVENTS.ERROR, payload);
  }
}
(0, _eventEmitter.default)(Pages.prototype);
const pages = new Pages();
exports.pages = pages;